module.exports = "<svg viewBox=\"0 0 25 25\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"none\" stroke=\"#FFFFFF\" fill-rule=\"evenodd\" opacity=\".7\">\n        <path d=\"M0.5,12.5a12,12 0 1,0 24,0a12,12 0 1,0 -24,0\" />\n        <path\n            d=\"M10.5 9.5h4V8c0-.83-.67-1.5-1.5-1.5h-1c-.83 0-1.5.67-1.5 1.5v1.5zM8.56 9.5l.74 6.67a1.5 1.5 0 0 0 1.49 1.33h3.42c.76 0 1.4-.57 1.5-1.33l.73-6.67H8.56z\"\n        />\n        <path d=\"M7 9.5h11\" stroke-linecap=\"round\" />\n    </g>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./public/img/bin-circle.svg
// module id = hcE+
// module chunks = 5